module.exports = __webpack_public_path__ + "static/reason-5-cd9aa4271e3251e089c14a8dbec8cb31.svg";